import React from 'react'
import { DI } from 'modules'
import { NavLink } from 'react-router-dom'

function Submenu(props) {
  const {
    common: { strings },
  } = props
  return (
    <div className="page-submenu page-submenu--short">
      <ul className="page-submenu-list page-submenu-list--short">
        {props.menu.aboutMenu.map(item => (
          <li className="page-submenu-item">
            <NavLink
              to={item.localeLink}
              className="page-submenu__link"
              activeClassName="_active"
              exact
            >
              {item.title}
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="page-submenu-dropdown page-submenu-dropdown--short">
        <button type="button" className="page-submenu-dropdown__current">
          About {strings['site.name']}
        </button>
        <div className="page-submenu-dropdown-body">
          {props.menu.aboutMenu.map(item => (
            <div className="page-submenu-dropdown-item">
              <NavLink
                to={item.localeLink}
                className="page-submenu-dropdown__item"
                exact
              >
                {item.title}
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DI(['menu', 'common'])(Submenu)
